import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import ListEditions from "./List";
import EditEditions from "./Edit";
import ShowEditions from "./Show";
//params
export const EDITIONS = "editions";

//permissions

export const resources = {
  isMenu: true,
  icon: <CreditCardOutlinedIcon />,
  name: EDITIONS,
  title: "Абонаменти",
  list: <ListEditions />,
  edit: <EditEditions />,
  show: <ShowEditions />,
  permission: "editions",
};

//api url
